<script>
  export default {
    name: 'Home',
    created(){
      if(this.$store.state.auth.user){
        this.$router.push('/dashboard');
      } else {
        this.$router.push('/auth/login');
      }
    }
  }
</script>